<template>
  <div>
    
    <MemberEditorCompactModal
      ref="member-editor"
      :member_id="selected_member_id"

      @created="member_created"
      @updated="member_updated"
      @deleted="member_deleted"
    />

    <m-row>
      <m-col lg="6">
        <div class="bottom-alignment">
          <strong>{{ $t('COMMON.NUM_ROWS') }}:</strong> {{ total_rows }}
        </div>
      </m-col>
      <m-col lg="6">
        <div class="d-sm-flex justify-content-end align-items-right align-bottom w-100 mb-2">

          <memlist-pagination 
            :per_page="per_page" 
            :total_rows="total_rows" 
            @page-changed="current_page = $event"
            @per-page-changed="per_page = $event"
            aria-controls="search-result-table"
          />

        </div>
      </m-col>
    </m-row>

    <memlist-ajax-table
      ref="birthdays-table"
      :fields="headers"
      :items="ajax_pagination"
      :per_page="per_page"
      :current_page="current_page"
      @sort-changed="onSortChanged"
    >
      <template #cell(actions)="data">
        <memlist-table-button class="mr-3" @click="select_item_clicked(data.item.id)" svg="/assets/svg/pencil-square.svg" :tooltip="$t('COMMON.EDIT')" />
      </template>
    </memlist-ajax-table>
  </div>
</template>

<script>
import { toasts } from '@/core/mixins/toastr-helper.mixin.js';
import { mapGetters } from 'vuex';
import axios from 'axios';
import dayjs from 'dayjs';

export default {
  name: 'BirthdaysHistory',
  mixins: [toasts],
  emits: [],
  computed: {
    ...mapGetters(['currentCompanyId', 'currentPeriodId', 'settings']),
    

    // Define headers using snake_case for keys
    headers() {
      return [
        {
          label: this.$t('BIRTHDAYS_MODULE.SEND_AT'),
          sortable: true,
          key: 'dob',
          tdClass: 'td-short4',
          thClass: 'td-short4',
          formatter: (_, __, item) => {
            return dayjs(item.dob).format('YYYY-MM-DD');
          },
        },
        {
          label: this.$t('MEMBER.PUBLIC_ID'),
          sortable: true,
          key: 'public_id',
          tdClass: 'td-short3',
          thClass: 'td-short3'
        },
        {
          label: this.$t('MEMBER.FIRSTNAME'),
          sortable: true,
          key: 'firstname',
          tdClass: 'td-short4',
          thClass: 'td-short4'
        },
        {
          label: this.$t('MEMBER.LASTNAME'),
          sortable: true,
          key: 'lastname',
          tdClass: 'td-short4',
          thClass: 'td-short4'
        },
        {
          label: this.$t('MEMBER.AGE'),
          sortable: true,
          key: 'age',
          tdClass: 'td-short3',
          thClass: 'td-short3',
          formatter: (_, __, item) => {
            return dayjs().diff(dayjs(item.dob), 'year') + 1;
          },
        },
        {
          label: this.$t('BIRTHDAYS_MODULE.SMS'),
          sortable: true,
          key: 'sms',
          tdClass: 'td-short3',
          thClass: 'td-short3',
          formatter: (_, __, item) => {
            if (item.phone) {
              return this.$t('BIRTHDAYS_MODULE.EXISTS');
            }

            return this.$t('BIRTHDAYS_MODULE.NOT_EXISTS');
          },
        },
        {
          label: this.$t('BIRTHDAYS_MODULE.EMAIL'),
          sortable: true,
          key: 'email',
          tdClass: 'td-short3',
          thClass: 'td-short3',
          formatter: (_, __, item) => {
            if (item.email) {
              return this.$t('BIRTHDAYS_MODULE.EXISTS');
            }

            return this.$t('BIRTHDAYS_MODULE.NOT_EXISTS');
          },
        },

        {
          label: this.$t('COMMON.ACTIONS'),
          key: 'actions',
          sortable: false,
          tdClass: 'td-short3',
          thClass: 'td-short3',
        }
      ];
    }
  },
  async mounted() {
    await this.get_birthday_history();
  },
  data() {
    return {
      
      selected_member_id: null,
      orderBy: null,
      total_rows: 0,
      current_page: 1,
      per_page: 100,
      search: null
    };
  },
  watch: {
    current_page() {
      this.$refs['birthdays-table'].refresh();
    },
  
  },
  methods: {

    select_item_clicked(member_id) {
      this.selected_member_id = member_id;
      this.$refs['member-editor'].show();
    },
    member_created(member) {},
    member_updated(member) {},
    member_deleted(member) {},
    
    onSortChanged(sortChanged) {

      if (sortChanged.sortBy === '') {
        this.orderBy = undefined;
      }
      else {
        this.orderBy = {

        };

        this.orderBy[sortChanged.sortBy] = sortChanged.sortDesc ? 'desc' : 'asc';
      }
    },


    async get_birthday_history() {

      const res = await axios.get(`/birthday/history?scheduled_from=${dayjs().subtract(1, 'days').format('YYYY-MM-DD')}&scheduled_to=${dayjs().add(1,'days').format('YYYY-MM-DD')}`)
        
      if (res.status === 200) {
        return res.data;
      }
      
    },

    get_pagination(callback) {

      axios
        .post(`/member/pagination`, { 
          options: {
            statuses: ['MEMBER'],
            birthday_in_days: 7
          }
        })
        .then(async res => {
          if (res.status !== 200) {
            console.error('pagination: invalid status', res.status);
            return;
          }
          if (callback) {

            const tobesent = [];

            const history = await this.get_birthday_history();

            console.log('history', history);

            for (const member of res.data) {
              tobesent.push(member);
            }

            callback(tobesent || []);
          }
        })
        .catch(err => {
          console.error('pagination error', err);
        });
    },
    get_count() {
      axios
        .post(`/member/pagination/count`, { 
          options: {
            statuses: ['MEMBER'],
            birthday_in_days: 7
          }
        })
        .then(res => {
          if (res.status !== 200) {
            console.error('pagination count: invalid status', res.status);
            return;
          }
          this.total_rows = res.data.count;
        })
        .catch(err => {
          console.error('pagination count error', err);
        });
    },
    ajax_pagination(ctx, callback) {
      this.get_count();
      this.get_pagination(callback);
      return null;
    },
    refresh() {
      this.$refs['birthdays-table'].refresh();
    }
  }
};
</script>

<style lang="scss" scoped>



</style>
